import React, { useEffect, useState } from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
import AcademicCommoncrd from '../../AcademicCommoncrd/AcademicCommoncrd';
import CompletionStage from '../CompletionStage/CompletionStage';
const CallParticipation = () => {
    const [participateInfo, setParticipateInfo] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.callPartipat,
            })
            .then((response) => {
                const paticipateDoc = response.data.allParticipations.edges[0].node;
                setParticipateInfo(paticipateDoc);
            })
            .catch((error) => {
                console.error(error);
            });
    });


    return (
        <div className="participation-container ">
            <h5 className="robot-challenge-title">{participateInfo?.sub_title1[0]?.text}</h5>
            <p className="body-text">{participateInfo?.sub_description1[0]?.text}</p>
            <div className="d-flex pt-2 pb-3 justify-content-center">
                <button className="primary-btn     ">Register</button>
            </div>
            {participateInfo?.stage?.map((stage, index) => <CompletionStage key={index + 1} stage={stage}></CompletionStage>)}

            <div className="row g-2 pt-5">
                {participateInfo?.card?.map((info, index) =>
                    <AcademicCommoncrd
                        info={info}
                        callPartCard={true}
                        crdHight={540}
                        key={index + 1}
                    >
                    </AcademicCommoncrd>)
                }


            </div>
            <div className="participation-footer pt-5">
                <h5>{participateInfo?.email_text[0]?.text} {""}

                    <a target="_blank" href={"mailto:" + participateInfo?.email[0]?.text}>{participateInfo?.email[0]?.text}</a></h5>

                <p className="body-text">{participateInfo?.email_text_description[0]?.text}</p>
            </div>


        </div>
    );
};

export default CallParticipation;